import GE_icon from '@/assets/logo/GE.png'
import GOODWE_icon from '@/assets/logo/GOODWE.png'
import LG_icon from '@/assets/logo/LG.png'
import ODM_icon from '@/assets/logo/ODM.png'
import SoloarGoIcon from './img/solargo.png'
import SolarGoApp from './img/solarGoApp.png'
import SolarPlusApp from './img/solarPlusApp.png'
// import SolarPlusApp from './img/solarPlusApp.png'
import SolarPlusIcon from './img/solarPlusIcon.png'
import SemsPlusPlusIcon from './img/sems_plus_plus.png'
import PvMasterGoIcon from './img/pvmaster.png'
import SemsPortalIcon from './img/semsportal.png'
import SemsPlusPlusZh from './img/semsPlusPlus_zh.png'
import SemsPlusPlusEn from './img/semsPlusPlus_en.png'
import SemsPortalZhIcon from './img/semsPortalZh.png'
import SemsPortalIconNew from './img/semsPortalIcon.png'
import SemsPortalImg from './img/semsPortalImg.png'
import SemsPortalZhApp from './img/semsPortalZhApp.png'
import WEMateIcon from './img/logo/WEMate.png'
import StorageMateIcon from './img/logo/StorageMate.png'
import SolarPortalIcon from './img/logo/SolarPortal.png'
import PowerSightIcon from './img/logo/PowerSight.png'
import LGESPVMasterIcon from './img/logo/LGESPVMaster.png'
import LGRESUHOMEIcon from './img/logo/LGRESUHOME.png'

export const POST = 'POST'
export const GET = 'GET'
export const PUT = 'PUT'
export const PATCH = 'PATCH'
export const DELETE = 'DELETE'
export const PLATFORM = 'WEB'
export const STATUS_SUCCESS = 200
export const STATUS_FAIL = 400
export const STATUS_NOT_AUTH = 499
export const STATUS_RENEWAL = 307
export const FETCH_TIMEOUT = 10 * 1000
export const LOGOUT_TIME_DELAY = 1000

export const HTTP_STATUS_OK = 200
export const HTTP_STATUS_UNAUTHORIZED = 401

export const CONTENT_TYPE = 'Content-Type'
export const CONTENT_TYPE_JSON = 'application/json'
export const CONTENT_TYPE_FORM_URLENCODED = 'application/x-www-form-urlencoded'

// 厂家
export const COMPANY_GOODWE = 0 //  'GOODWE'
export const COMPANY_ODM = 1 //  'ODM'
export const COMPANY_LG = 2 //  'LG'
export const COMPANY_GE = 3 //  'GE'

export const COMPANY_TEXT_MAP = {
  [COMPANY_GOODWE]: 'GOODWE',
  [COMPANY_ODM]: 'ODM',
  [COMPANY_GE]: 'GE',
  [COMPANY_LG]: 'LG',
}

//  厂家域名map
export const COMPANY_HOST_URL_MAP = {
  [COMPANY_GOODWE]: 'GOODWE_HOST_URL',
  [COMPANY_ODM]: 'ODM_HOST_URL',
  [COMPANY_GE]: 'GE_HOST_URL',
  [COMPANY_LG]: 'LG_HOST_URL',
}

//  厂家iconmap
export const COMPANY_ICON_MAP = {
  [COMPANY_GOODWE]: GOODWE_icon,
  [COMPANY_ODM]: ODM_icon,
  [COMPANY_GE]: GE_icon,
  [COMPANY_LG]: LG_icon,
}

// app名称KEY
export const APP_KEY_SOLARGO = 'SolarGo'
export const APP_KEY_PVMASTER = 'PVMaster'
export const APP_KEY_SEMSPORTAL = 'SEMSPortal'
export const APP_KEY_WEMATE_ODM = 'WEMateODM'
export const APP_KEY_STORAGEMATE_ODM = 'StorageMateODM'
export const APP_KEY_SOLARPORTAL = 'SolarPortal'
export const APP_KEY_WEMATE_GE = 'WEMateGe'
export const APP_KEY_STORAGEMATE_GE = 'StorageMateGE'
export const APP_KEY_POWERSIGHT = 'PowerSight'
export const APP_KEY_LGESPVMASTER = 'LGESPVMaster'
export const APP_KEY_LGRESUHOME = 'LGRESUHOME'

export const ALL_APP_MAP: Record<string, ICompanyAppMapItem> = {
  [APP_KEY_SOLARGO]: {
    icon: SoloarGoIcon,
    name: 'SolarGo',
    download_url: 'https://www.sems.com.cn/home/solargo',
    description_key: 'SOLARGO_EXPLAIN_LABEL',
  },
  [APP_KEY_PVMASTER]: {
    icon: PvMasterGoIcon,
    name: 'PV Master',
    download_url: 'https://www.semsportal.com/home/pvmaster',
    description_key: 'PVMASTER_EXPLAIN_LABEL',
  },
  [APP_KEY_SEMSPORTAL]: {
    icon: SemsPortalIcon,
    name: 'SEMS Portal',
    download_url: 'https://www.semsportal.com/home/AppDownload',
    name_zh: '小固云窗',
    download_url_zh: 'https://www.sems.com.cn/home/AppDownload',
    description_key: 'SEMSPORTAL_EXPLAIN_LABEL',
  },
  [APP_KEY_WEMATE_ODM]: {
    icon: WEMateIcon,
    name: 'WE Mate',
    download_url: 'https://www.pvsolarportal.com/home/wemate',
    description_key: 'WEMATE_EXPLAIN_LABEL',
  },
  [APP_KEY_STORAGEMATE_ODM]: {
    icon: StorageMateIcon,
    name: 'StorageMate',
    download_url: 'https://www.pvsolarportal.com/home/storagemate',
    description_key: 'STORAGEMATE_EXPLAIN_LABEL',
  },
  [APP_KEY_SOLARPORTAL]: {
    icon: SolarPortalIcon,
    name: 'SolarPortal',
    download_url: 'https://www.pvsolarportal.com/home/AppDownload',
    description_key: 'SOLARPORTAL_EXPLAIN_LABEL',
  },
  [APP_KEY_WEMATE_GE]: {
    icon: WEMateIcon,
    name: 'WE Mate',
    download_url: 'https://portal.gesolarinverter.com/home/wemate',
    description_key: 'WEMATE_EXPLAIN_LABEL',
  },
  [APP_KEY_STORAGEMATE_GE]: {
    icon: StorageMateIcon,
    name: 'StorageMate',
    download_url: 'https://portal.gesolarinverter.com/home/storagemate',
    description_key: 'STORAGEMATE_EXPLAIN_LABEL',
  },
  [APP_KEY_POWERSIGHT]: {
    icon: PowerSightIcon,
    name: 'Power Sight',
    download_url: 'https://portal.gesolarinverter.com/home/AppDownload',
    description_key: 'POWERSIGHT_EXPLAIN_LABEL',
  },
  [APP_KEY_LGESPVMASTER]: {
    icon: LGESPVMasterIcon,
    name: 'LGES PV Master',
    download_url: 'https://www.lgresuhomemonitor.com/home/lgespvmaster',
    description_key: 'LGESPVMASTER_EXPLAIN_LABEL',
  },
  [APP_KEY_LGRESUHOME]: {
    icon: LGRESUHOMEIcon,
    name: 'LG RESU HOME',
    download_url: 'https://www.lgresuhomemonitor.com/home/AppDownload',
    description_key: 'LGRESUHOME_EXPLAIN_LABEL',
  },
}

// 充电桩app
export const CHARGING_PILE_APP_LIST = [APP_KEY_SOLARGO, APP_KEY_SEMSPORTAL]

export const languageMap: Record<string, string> = {
  en: 'en', //  English
  'zh-cn': 'cn', //  中文
  'de-de': 'de', //  德语
  'it-it': 'it', //  意大利语
  'vi-vi': 'vi', //  越南语
  'cs-cz': 'cs', //  捷克语
  'fr-fr': 'fr', //  法语
  'pt-pt': 'pt', //  葡萄牙语
  'po-pl': 'pl', //  波兰语
  'ja-ja': 'ja', //  日语
  'ko-kr': 'ko', //  韩语
  'es-es': 'es', //  西班牙语
}

// 所有中转页面
export const TRANSFER_PAGE_SOLARGO = 'solarGo' // solarGo
export const TRANSFER_PAGE_SEMSPLUSZH = 'semsPlusZh' // SEMS+ 小固云窗
export const TRANSFER_PAGE_SEMSPLUSEN = 'semsPlusEn' // SEMS+
export const TRANSFER_PAGE_SEMSPLUSAPP = 'semsPlusApp' // SEMS+
export const TRANSFER_PAGE_SEMSPORTAL = 'semsPortal' //SEMS Portal
export const TRANSFER_PAGE_SEMSPORTALP_ZH = 'semsPortalZh' // 小固云窗

export const TRANSFER_PAGE_MAP = {
  [TRANSFER_PAGE_SOLARGO]: {
    name: 'SolarGo',
    icon: SoloarGoIcon,
    img: SolarGoApp,
    android: 'https://play.google.com/store/apps/details?id=com.goodwe.solargo',
    ios: 'https://itunes.apple.com/app/id1398200252',
  },
  [TRANSFER_PAGE_SEMSPLUSZH]: {
    name: '小固云窗+',
    name_zh: '小固云窗+',
    icon: SemsPlusPlusIcon,
    img: SemsPlusPlusZh,
    android:
      'https://play.google.com/store/apps/details?id=com.goodwe.sems.plus',
    ios: 'https://itunes.apple.com/app/6755710856',
  },
  [TRANSFER_PAGE_SEMSPLUSEN]: {
    name: 'SEMS+',
    name_zh: 'SEMS+',
    icon: SemsPlusPlusIcon,
    img: SemsPlusPlusEn,
    android:
      'https://play.google.com/store/apps/details?id=com.goodwe.sems.plus',
    ios: 'https://itunes.apple.com/app/6755710856',
  },
  [TRANSFER_PAGE_SEMSPLUSAPP]: {
    name: 'SEMS+ Classic',
    isNew: false,
    icon: SolarPlusIcon,
    img: SolarPlusApp,
    android: 'https://play.google.com/store/apps/details?id=com.goodwe.semscn',
    ios: 'https://apps.apple.com/app/1619741965',
  },
  [TRANSFER_PAGE_SEMSPORTAL]: {
    name: 'SEMS Portal',
    icon: SemsPortalIconNew,
    img: SemsPortalImg,
    android:
      'https://play.google.com/store/apps/details?id=com.goodwe.semsportal',
    ios: 'https://itunes.apple.com/cn/app/sems-portal/id1406230958',
  },
  [TRANSFER_PAGE_SEMSPORTALP_ZH]: {
    name: '小固云窗',
    icon: SemsPortalZhIcon,
    img: SemsPortalZhApp,
    // android: 'https://play.google.com/store/apps/details?id=com.goodwe.solargo',
    ios: 'https://itunes.apple.com/cn/app/id1329322574',
  },
}
